
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59 12.81c-7.76 0-8-8.12-14.53-8.12s-6.77 8.12-14.53 8.12h.12c-7.76 0-8-8.12-14.53-8.12S8.76 12.81 1 12.81M59 34.06c-7.76 0-8-8.12-14.53-8.12s-6.77 8.12-14.53 8.12h.12c-7.76 0-8-8.12-14.53-8.12S8.76 34.06 1 34.06M59 55.31c-7.76 0-8-8.12-14.53-8.12s-6.77 8.12-14.53 8.12h.12c-7.76 0-8-8.12-14.53-8.12S8.76 55.31 1 55.31","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    